import React from 'react';
import CreateSpark from 'components/CreateSpark';
import SparkRuns from 'components/SparkRuns';
import { Navigate, Route, Routes } from 'react-router-dom';
import { WorkSpaceContextProvider } from 'components/Providers/ContextProviders';
import MainAppRouts from './MainAppRouts';
import SettingsRouts from './SettingsRouts';
import TempProdScreen from 'components/common/FallBack/TempProdScreen';
import { useEnvironment } from 'hooks/useEnvironment';
import { SPARK_ROUTES } from 'constants/routes';
import MemoryQA from 'components/Memories/MemoryQA';
import StatusBar from 'components/common/StatusBar';
import { initializeSurveyJS } from 'utilities/surveyJS';
import SparkRunDetailsContainer from 'components/SparkRunDetailsPage/SparkRunDetailsContainer';
import SparkBoardBuilder from 'components/SparkBoardBuilder';
import TestRoute from 'components/TestRoute';

initializeSurveyJS();

function UserRouts() {
  const { isProduction } = useEnvironment();
  return (
    <WorkSpaceContextProvider>
      <StatusBar />
      {isProduction ? (
        <Routes>
          <Route path='/*' element={<Navigate to='/stay-tuned' />} />
          <Route path='/stay-tuned' element={<TempProdScreen />} />
        </Routes>
      ) : (
        <Routes>
          <Route path='/*' element={<MainAppRouts />} />
          <Route path='/settings/*' element={<SettingsRouts />} />
          <Route
            path={`${SPARK_ROUTES.BOARD}/:id`}
            element={<SparkBoardBuilder />}
          />
          <Route
            path={`${SPARK_ROUTES.SPARK_BUILDER}/:id?`}
            element={<CreateSpark />}
          />
          <Route path={`${SPARK_ROUTES.MEMORY}/:id`} element={<MemoryQA />} />
          <Route
            path={`${SPARK_ROUTES.SPARK_RUNS}/:id`}
            element={<SparkRuns />}
          />
          <Route
            path={`${SPARK_ROUTES.SPARK_RUN_DETAIL}/:id`}
            element={<SparkRunDetailsContainer />}
          />
          <Route path={'test-route-for-chats'} element={<TestRoute />} />
        </Routes>
      )}
    </WorkSpaceContextProvider>
  );
}

export default UserRouts;
